import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import { SessionContextStore } from '../../context/SessionContext'
import { SessionService } from '../../services/SessionService'
import PilotProfileImg from '../../assets/sidemenu/noprofile_image.png'

export const SideMenuUserCircle = () => {
  const session = useContext(SessionContextStore)
  let user = session.user //SessionService.isLoggedIn() && SessionService.isBroker() && session.broker ? session.broker : session.user
  const profile = !!user.profilePicture ? user.profilePicture : PilotProfileImg
  return (
    <FlexView column hAlignContent={'center'} vAlignContent={'center'} className="sky-side-menu-user-container">
      {SessionService.isLoggedIn() && <img src={profile} className="sky-side-menu-user-profile" />}
      <div className="text-small powderblue margin-top-6">
        {SessionService.isBroker() || !user.firstName ? user.firstName : `Hi, ${user.firstName}!`}
      </div>
      <div className="text-tiny powderblue">{user.email}</div>
    </FlexView>
  )
}
